// project import
import dashboard from './dashboard';
import administrators from './administrators';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, administrators]
};

export default menuItems;
